const emitEvent = (pluginId: string, data: Record<string, unknown> | unknown[]) => {
  const event = new CustomEvent('fu-tools-event', {
    detail: {
      pluginId,
      params: Array.isArray(data) ? data : [data],
    },
  })

  document.dispatchEvent(event)
}

export { emitEvent }
